import { Clue } from "./Clue";

export class WordSet {
    _id: string;
    date: string;
    codes: string[];
    clues: Clue[];

    constructor(rws: any, id: string = "") {
        this._id = id;
        if (rws != null) {
            this.date = rws.date;
            this.codes = rws.codeWords || rws.codes;
            this.clues = (rws.relatedWords || rws.clues).map((rw: any) => new Clue(rw, rws.relatedWords ? this.codes : null));
        } else {
            this.date = "";
            this.codes = [];
            this.clues = [];
        }
    }

    toPojo() {
        return {
            date: this.date,
            codeWords: this.codes,
            clues: this.clues.map((clue) => clue.toPojo()),
            isToday: false
        };
    }
};